/**
 * Parental gate (2026-09-05) — the adult check between a child's "<13" answer
 * on the Play Families age screen and the parent's sign-up. Google Sign-In
 * is not approved for child users, so an install that declared <13 hides it;
 * a parent who passes this gate unlocks it for a short while (the account is
 * the parent's). Pure rules live here for Jest; storage in lib/ageGate.ts.
 *
 * Kai's rule: one factor 6–9, the other 3–9 — single-digit multiplication
 * that a 3–8-year-old cannot do, needs no number words in 14 languages.
 */
export const GATE_ATTEMPTS = 3;
export const PARENT_VERIFIED_TTL_MS = 15 * 60 * 1000;

export interface Challenge {
  a: number;
  b: number;
  answer: number;
}

export function makeChallenge(rand: () => number = Math.random): Challenge {
  const big = 6 + Math.floor(rand() * 4);    // 6..9
  const small = 3 + Math.floor(rand() * 7);  // 3..9
  const [a, b] = rand() < 0.5 ? [big, small] : [small, big];
  return { a, b, answer: a * b };
}

export function checkAnswer(challenge: Challenge, input: string): boolean {
  const s = input.trim();
  return /^\d{1,3}$/.test(s) && parseInt(s, 10) === challenge.answer;
}

/** True while the stored expiry (epoch ms) lies in the future. */
export function isParentVerified(untilMs: number | null | undefined, now: number = Date.now()): boolean {
  return typeof untilMs === 'number' && Number.isFinite(untilMs) && untilMs > now;
}
